<main [attr.aria-busy]="loading">
  <aside *ngIf="preview" class="recipient-preview-notice" role="note">
    <strong>Saved content preview</strong>
    <p>Includes unpublished and scheduled content. Save your edits before opening this preview. Nothing is published by previewing.</p>
    <p *ngIf="story">{{ previewStatus }}<span *ngIf="story.RevealAtDateTime"> · Reveal date: {{ story.RevealAtDateTime | date:'medium' }}</span></p>
  </aside>
  <app-recipient-loading-skeleton *ngIf="loading" mode="detail"></app-recipient-loading-skeleton>
  <header *ngIf="story" class="recipients-hero">
    <div class="recipients-hero-inner">
      <a *ngIf="!preview" class="recipient-hero-back" [routerLink]="returnPath">← Recipient stories</a>
      <p class="eyebrow">{{ story.ChallengeDefinition?.Name }}</p>
      <h1 id="recipient-story-title">{{ story.RecipientName }}</h1>
      <p>{{ story.ShortDescription }}</p>
    </div>
  </header>
  <div *ngIf="!loading" class="recipient-page">
  <div *ngIf="error" role="alert"><p>{{ error }}</p><button type="button" class="btn btn-outline-primary" (click)="reload()">Try again</button></div>
  <section *ngIf="!loading && !error && !story"><h1>Story unavailable</h1><p>This story may not have been revealed yet.</p><a routerLink="/recipients">Meet the recipients</a></section>
  <article *ngIf="story" aria-labelledby="recipient-story-title">
    <app-recipient-story-body [html]="story.FullDescriptionHtml" [photos]="story.Photos" [photoDescription]="story.RecipientName"></app-recipient-story-body>
    <section *ngIf="updatesLoading || updatesError || updates.length" class="recipient-updates" aria-labelledby="recipient-updates-title"><h2 id="recipient-updates-title">Updates</h2>
      <app-recipient-loading-skeleton *ngIf="updatesLoading" mode="updates"></app-recipient-loading-skeleton>
      <div *ngIf="updatesError" role="alert"><p>{{ updatesError }}</p><button type="button" class="btn btn-outline-primary" (click)="reload()">Try again</button></div>
      <article *ngFor="let update of updates" class="recipient-update"><time [attr.datetime]="update.PublishAtDateTime">{{ update.PublishAtDateTime | date:(preview ? 'medium' : 'longDate') }}</time>
        <p *ngIf="preview" class="recipient-preview-status">{{ updateStatus(update) }}</p>
        <h3>{{ update.Title }}</h3>
        <app-recipient-story-body [html]="update.BodyHtml" [photos]="update.Photos" [photoDescription]="update.Title"></app-recipient-story-body>
      </article>
    </section>
  </article>
  <a *ngIf="!preview" routerLink="/recipients/previous">Previous recipients →</a>
  </div>
</main>
